import { VTab } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTab,_vm._b({class:_vm.gatedClass,on:{"change":function($event){_vm.onAction($event, 'change')}}},'v-tab',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }